import { keys, reduce, isNil } from 'lodash';
import { Validations, Helpers } from '@utils/helpers';
import { IError } from '@utils/useForm';
import { BasicDetailsForm } from '@models/SIO/BasicDetails.model';

export const validate = (values: BasicDetailsForm) => {
  const fields = keys(values);
  const errors: any = reduce(fields, (result, field: string) => {
    return { ...result, [field]: validateField(values, field) };
  }, {});
  return errors;
}

export const validateField = (values: any, name: string) => {
  const value = values[name];
  let error: IError | undefined = { isValid: true };
  switch(name) {
    case 'scheme':
    case 'required1':
    case 'required2':
      if (!value) {
        error = { isValid: false }
      }
      break;
     
  }
  return error;
}
